export default "__VITE_ASSET__DwPolTWL__"